(function() {
    'use strict';

    angular
        .module('atheer.system')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider
            .state('storm.admin-setting.apps', {
                url: '/apps?page&sort&search',
                templateUrl: 'modules/system/app/apps.tmpl.html',
                controller: 'AppController',
                controllerAs: 'vm',
                data: {
                    pageTitle: 'atheer.app.home.title',
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false,
                        showSideNavMenu: true,
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('storm.admin-app-detail', {
                url: '/settings/app/:name',
                templateProvider: function($templateRequest, $stateParams, INTEGRATION_APP_META) {
                    var meta = INTEGRATION_APP_META[$stateParams.name];
                    if (meta) {
                        return $templateRequest(meta.template);
                    } else {
                        return $templateRequest('modules/system/app/app-detail.tmpl.html');
                    }
                },
                controllerProvider: function($stateParams, INTEGRATION_APP_META) {
                    var meta = INTEGRATION_APP_META[$stateParams.name];
                    if (meta) {
                        return meta.controller;
                    } else {
                        return 'AppDetailController';
                    }
                },
                controllerAs: 'vm',
                data: {
                    layout: {
                        contentClass: 'layout-column',
                        footer: false,
                        showToolbar: false
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    appName: function($stateParams) {
                        return $stateParams.name;
                    }
                }
            });
    }
})();
